import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Deposito } from '../../../../types/Deposito.type';

@Injectable({
  providedIn: 'root'
})
export class DepositosService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll() {
    return this.httpClient.get<Deposito[]>(this.configService.getApiUrlRoot() + "/depositos/");
  }

  exportar(){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/depositos/relatorios/exportar`, { responseType: 'blob' })
  }

}
